'use client';

import mixpanel, { Config } from 'mixpanel-browser';

import { useEffect } from 'react';

const mixpanelProjectToken = process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN;

const mixpanelCommonConfig = {
	ignore_dnt: true,
};

const mixpanelEnvTestConfig = {
	debug: false,
	record_sessions_percent: 0, // explicitly disable session recording
};

const mixpanelEnvProdConfig: Partial<Config> = {
	api_host: 'https://sm-proxy.superdm.me',
	// record_sessions_percent: 25, // recording 25% of all sessions
	record_sessions_percent: 0, // explicitly disable session recording
};

const mixpanelEnvConfig =
	process.env.NEXT_PUBLIC_MIXPANEL_ENV === 'production'
		? mixpanelEnvProdConfig
		: mixpanelEnvTestConfig;

// Module-level guard — useEffect runs twice in StrictMode, init() must only fire once.
let initialized = false;

function initMixpanel() {
	if (initialized || typeof window === 'undefined' || !mixpanelProjectToken) return;
	initialized = true;
	try {
		mixpanel.init(mixpanelProjectToken, {
			...mixpanelCommonConfig,
			...mixpanelEnvConfig,
		});
		mixpanel.register({
			device_useragent: window.navigator.userAgent,
			web_app_version: process.env.NEXT_PUBLIC_APP_VERSION || 'unknown',
		});
	} catch (error) {
		console.error('Failed to initialize Mixpanel:', error);
	}
}

// Rendered once from the root layout. Side-effect-only imports of 'use client' modules
// don't fire their top-level code under Next 16 + Turbopack — the module gets registered
// as a client reference but never instantiated. Rendering this component guarantees init runs.
export default function MixpanelInit() {
	useEffect(() => {
		initMixpanel();
	}, []);
	return null;
}
